export const meta = { id: 'O06', slug: 'gestao-e-metodologia', title: 'Conheça Gestão e Metodologia', description: 'Entenda como Metodologia, Competências, Níveis e Descritores sustentam o Diagnóstico.', profile: 'owner', category: 'metodologia', type: 'screen', status: 'published', order: 360, keywords: ['metodologia','competências','níveis','descritores','diagnóstico'], previous: 'O05', next: 'O07', related: ['O08','O09','O10','O11'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Conheça Gestão e Metodologia

A metodologia organiza a base que orienta avaliação e desenvolvimento no Personagrama.

**Metodologia → Competências → Níveis → Descritores → Diagnóstico**

<HelpImage pendingId="O07.1" alt="Tela de Gestão e Metodologia" />

<Callout type="important">A estrutura oficial é administrada pelo Owner. O Mentor utiliza essa referência no acompanhamento, mas não altera a metodologia oficial.</Callout>
